import React from 'react'
import { Button, WImage } from '@components/atoms'
import styles from './PDPInfoCard.module.sass'
import { MenuItemType } from '@utils/types'

interface Props {
  item?: MenuItemType
  variant?: 'default' | 'light'
  className?: string
  nextImage?: boolean
}

const PDPInfoCard = (props: Props) => {
  const { item, variant = 'default', className = '', nextImage = false } = props

  return item ? (
    <article className={`${styles.root} ${styles[`root--${variant}`]} ${className}`}>
      <div className={styles.imageBox}>
        <WImage
          src={item.image}
          maxWidth={229}
          maxHeight={180}
          objectFit="cover"
          alt={item.name}
          next={nextImage}
        />
      </div>
      <div className={styles.main}>
        <h3 className={styles.title}>{item.name}</h3>
        <div
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: item.description }}
        />
        {item.url && (
          <Button href={item.url ?? '#'} variant="ghost" size="sm" label="Leggi il volantino" />
        )}
      </div>
    </article>
  ) : (
    <></>
  )
}

export default PDPInfoCard
